import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
export function ForYouSection() {
  return <section className="py-16 px-4 bg-white" data-id="element-291" data-mp="2826pn78acc1p">
      <div className="max-w-lg md:max-w-4xl mx-auto" data-id="element-292" data-mp="28154g9xk2969">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-293" data-mp="2cviyo90hea9c">
          {/* Not for you */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="bg-[#FFEBEE] p-8 rounded-3xl border border-[#FFCDD2]" data-id="element-294" data-mp="2hrzod7nbwwoj">
            <div className="flex items-center gap-3 mb-6" data-id="element-295" data-mp="1u2yjtvhma5oj">
              <div className="bg-[#EF5350] p-2 rounded-full text-white" data-id="element-296" data-mp="1z2jjk84m2i2b">
                <X className="w-6 h-6" data-id="element-297" data-mp="1z0gnp7gs1upo" />
              </div>
              <h3 className="text-xl font-bold text-[#C62828]" data-id="element-298" data-mp="35i3sdg4fiyg2">
                ESTO NO ES PARA TI SI…
              </h3>
            </div>
            <ul className="space-y-4" data-id="element-299" data-mp="3ajt6j4my7s8d">
              {['Buscas una solución perfecta que funcione el primer día', 'Esperas que tu hijo coma todo inmediatamente', 'No estás dispuesta a aplicar el sistema aunque sea de forma imperfecta'].map((item, idx) => <li key={idx} className="flex gap-3 text-[#B71C1C]" data-id="element-300" data-mp="3spvbtmodlmf0" data-mpi={idx}>
                  <span className="shrink-0 mt-1 opacity-70" data-id="element-301" data-mp="3nrk2dd1ztdxb">
                    <X className="w-4 h-4" data-id="element-302" data-mp="3nrbrtrtcekpa" />
                  </span>
                  <span data-id="element-303" data-mp="3itilmys1hqp0">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* For you */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="bg-[#E8F5E9] p-8 rounded-3xl border border-[#C8E6C9]" data-id="element-304" data-mp="3e07f6yr53bxm">
            <div className="flex items-center gap-3 mb-6" data-id="element-305" data-mp="3017nfi8bygx8">
              <div className="bg-[#4CAF50] p-2 rounded-full text-white" data-id="element-306" data-mp="2v2mlnedfjp6o">
                <Check className="w-6 h-6" data-id="element-307" data-mp="2lfae2bowp99q" />
              </div>
              <h3 className="text-xl font-bold text-[#2E7D32]" data-id="element-308" data-mp="2ldz6e0scbhdc">
                ESTO ES EXACTAMENTE PARA TI SI…
              </h3>
            </div>
            <ul className="space-y-4" data-id="element-309" data-mp="2cf40kpt7k9ak">
              {['Quieres dejar de improvisar y tener un sistema real', 'Tu hijo rechaza alimentos y no sabes cómo manejarlo sin peleas', 'Quieres ofrecer comida más nutritiva pero no tienes horas libres', 'Sientes culpa en la mesa y quieres cambiar eso', 'Necesitas recetas que los niños realmente coman'].map((item, idx) => <li key={idx} className="flex gap-3 text-[#1B5E20]" data-id="element-310" data-mp="3943985xpfd3a" data-mpi={idx}>
                  <span className="shrink-0 mt-1" data-id="element-311" data-mp="2vcf1sfyehcsn">
                    <Check className="w-5 h-5 text-[#4CAF50]" data-id="element-312" data-mp="2vbncfmvecbat" />
                  </span>
                  <span className="font-medium" data-id="element-313" data-mp="2zcyv18furw9i">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}